module.exports = __webpack_public_path__ + "static/img/07063D_1_2_C_20210531_LC.bf6dbe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07063D_1_2_C_20210531_LC.png
// module id = l5gj
// module chunks = 0